module.exports = __webpack_public_path__ + "06_medium_gold.f87a4ddb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/06_medium_gold.png
// module id = cFEx
// module chunks = 0